import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const WrapperContainer = styled.div(({ theme }) => {
    return {
        padding: theme.spacing.medium,
        paddingTop: theme.spacing.xLarge,
    };
});

export const SubHeadingText = styled(Text)(({ theme }) => {
    return {
        marginTop: theme.spacing.small,
    };
});

export const CTAContainer = styled.div(({ theme }) => {
    return {
        marginTop: theme.spacing.medium,
        display: "flex",
        justifyContent: "space-between",
    };
});

export const SecondaryCTAButton = styled.div(({ theme }) => {
    return {
        width: "50%",
        marginRight: theme.spacing.small,
    };
});

export const PrimaryCTAButton = styled.div(() => {
    return {
        width: "50%",
    };
});
